import React from 'react';
import ConfirmDialog from '../Dialog/ConfirmDialog';

const InstallMobileAppModal = ({ visible, close, branchIoDomain }) => {
    const mobileDeepLink = location => {
        var iframe = document.createElement('iframe');
        iframe.src = location;

        // hide iframe visually
        iframe.width = 0;
        iframe.height = 0;
        iframe.frameBorder = 0;

        var now = new Date().valueOf();
        setTimeout(function () {
            if (new Date().valueOf() - now > 100) return;
            window.location = location;
        }, 10);

        // Append it to the body.
        document.body.appendChild(iframe);
        iframe.parentNode.removeChild(iframe);
    };

    return (
        <ConfirmDialog
            visible={visible}
            options={{
                title: 'Instal the mobile app',
                text: 'Get the app for a better mobile experience',
                cancelText: 'Not now',
                confirmText: 'Install',
                confirmIcon: 'get_app',
                confirm: () => {
                    mobileDeepLink(`https://${branchIoDomain}`);
                },
                cancel: close,
            }}
            onHideDialog={close}
        />
    );
};

export default InstallMobileAppModal;
